
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif"}},[_c('path',{attrs:{"d":"M9.014.059c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9.001-9zm0 1.688a7.299 7.299 0 017.313 7.31 7.299 7.299 0 01-7.313 7.314 7.299 7.299 0 01-7.312-7.313 7.299 7.299 0 017.31-7.311z","overflow":"visible"}}),_c('path',{attrs:{"d":"M12.972 4.84a.844.844 0 00-.715.363l-4.44 6.411L5.156 8.51a.844.844 0 00-1.19-.092.844.844 0 00-.093 1.19l3.375 3.938a.844.844 0 001.337-.068l5.062-7.313a.844.844 0 00-.213-1.176.844.844 0 00-.462-.149z","overflow":"visible"}})])])
          )
        }
      }
    